import { useEffect } from "react";
import { X } from "lucide-react";
import { resolveImageUrl } from "@/lib/apiClient";

export const ImageLightbox = ({ item, onClose }) => {
  useEffect(() => {
    if (!item) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [item, onClose]);

  if (!item) return null;
  const src = resolveImageUrl(item.source_image_url);
  return (
    <div
      data-testid="image-lightbox-modal"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 fade-up"
      onClick={onClose}
    >
      <button
        data-testid="close-lightbox-button"
        onClick={onClose}
        className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
      >
        <X className="h-5 w-5" />
      </button>
      <div
        className="max-w-3xl w-full rounded-2xl overflow-hidden border border-white/10 bg-card"
        onClick={(e) => e.stopPropagation()}
      >
        {src ? (
          <img src={src} alt={item.item_name} className="w-full max-h-[70vh] object-contain bg-black" />
        ) : (
          <div className="flex h-64 items-center justify-center text-muted-foreground">
            No source image
          </div>
        )}
        <div className="p-5 border-t border-border">
          <h3 className="font-heading text-lg font-bold text-slate-50">{item.item_name}</h3>
          <p className="mt-1 text-sm text-muted-foreground">{item.description}</p>
          {item.extracted_text && (
            <div className="mt-3 rounded-lg bg-secondary/50 p-3">
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">
                Extracted Text
              </div>
              <div className="font-mono text-xs text-primary break-words">{item.extracted_text}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
